import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { CustomState } from '../../../interface/custom-state.model';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-custom-state-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatInput,
    MatButton,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './custom-state-edit.component.html',
  styleUrl: './custom-state-edit.component.scss'
})
export class CustomStateEditComponent {

  form: FormGroup = new FormGroup({
    id: new FormControl(''),
    description: new FormControl('', [Validators.required]),
    color: new FormControl('', [Validators.required])
  })

  constructor(@Inject(MAT_DIALOG_DATA) data: {
    state?: CustomState
  }) {
    if (data && data.state) {
      this.form.patchValue(data.state)
    }
  }



}
